declare global {
  interface Window {
    turnstile?: {
      render(
        container: HTMLElement,
        params: Record<string, unknown>,
      ): number;
      execute(widgetId: number, params?: Record<string, unknown>): void;
    };
  }
}

let scriptPromise: Promise<void> | null = null;

function loadTurnstileScript(): Promise<void> {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise<void>((resolve, reject) => {
    if (window.turnstile) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => {
      scriptPromise = null;
      reject(new Error('gagal memuat turnstile'));
    };
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Token Turnstile invisible (non-interaktif, kueri lean). '' bila siteKey
 * kosong (mis. build dev tanpa site key) — worker menoleransi.
 */
export async function getTurnstileToken(siteKey: string): Promise<string> {
  if (!siteKey) return '';
  await loadTurnstileScript();
  const ts = window.turnstile;
  if (!ts) throw new Error('Turnstile tidak tersedia');
  // JANGAN display:none — widget Turnstile butuh container ter-render
  // (size 1px off-screen tetap ok), display:none membuat challenge
  // tak pernah jalan sehingga callback tak pernah datang (hang 8s).
  const el = document.createElement('div');
  el.style.cssText = 'position:absolute;left:-10000px;top:0;width:1px;height:1px;overflow:hidden;';
  document.body.appendChild(el);
  const cleanup = (): void => {
    el.remove();
  };
  return new Promise<string>((resolve, reject) => {
    let settled = false;
    const done = (fn: () => void): void => {
      if (settled) return;
      settled = true;
      cleanup();
      fn();
    };
    const widgetId = ts.render(el, {
      sitekey: siteKey,
      execution: 'execute',
      action: 'room',
      callback: (token: string) => done(() => resolve(token)),
      'expired-callback': () => done(() => resolve('')),
      'error-callback': () => done(() => reject(new Error('challenge gagal'))),
      'timeout-callback': () => done(() => reject(new Error('challenge timeout'))),
    });
    const tryExecute = (attempt: number): void => {
      try {
        ts.execute(widgetId, {});
      } catch {
        if (attempt < 3) window.setTimeout(() => tryExecute(attempt + 1), 200);
        else done(() => reject(new Error('gagal menjalankan turnstile')));
      }
    };
    window.setTimeout(() => tryExecute(0), 300);
  });
}